// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"pb_a bhb_cw bhb_jx bhb_jo bhb_a bhb_j bhb_ri bhb_rj","SearchPanel__icon":"pb_b bhb_ui bhb_hb bhb_ro bhb_tu","SearchPanel__input":"pb_c bhb_iv bhb_cx bhb_z"};